module.exports = __webpack_public_path__ + "img/emoji_101.62b401cb.png";